.card {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 18px;
}

.title {
  font-size: 18px;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 18px;
  border-top: 1.5px solid var(--ink);
  text-align: center;
}

.emptyTitle {
  font-size: 17px;
  font-weight: 700;
}

.emptyIntro {
  padding: 0 18px 18px;
  color: var(--ink-2);
}

.empty .emptyIntro {
  padding: 0;
}

.footer {
  padding: 14px 18px 18px;
  border-top: 1.5px solid var(--ink);
}

/* Both actions are links styled as the design system's buttons: Record is
 * the main action of an empty day, Edit the quieter one of a filled day. */
.record,
.edit {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border: var(--outline);
  border-radius: var(--radius-control);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}

.record {
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
}

.edit {
  background: var(--surface);
  color: var(--ink);
}
